export default __webpack_public_path__ + "1f481daa2a39a0b6332595434f6892cf.svg";